import React from 'react';
import { ChevronRight } from 'lucide-react';
export const CardSlide = ({ title, body, linkWrapper: LinkWrapper = null }) => {
    const cardContent = (React.createElement("div", { className: "h-full flex flex-col [&>*:first-child]:rounded-t-lg [&>*:last-child]:rounded-b-lg" },
        React.createElement("div", { className: "flex-grow px-5 pt-5 pb-[1.875rem] bg-white space-y-2.5 border border-brand-navy" },
            title && React.createElement("p", { className: "text-xl text-brand-navy font-medium" }, title),
            body && React.createElement("p", { className: "text-sm" }, body)),
        LinkWrapper && (React.createElement("div", { className: "w-full p-3 flex gap-1 items-center justify-center bg-brand-navy text-white" },
            React.createElement("span", { className: "text-xl/8 font-medium" }, "See all"),
            React.createElement(ChevronRight, { className: "size-7", "aria-hidden": "true" })))));
    // If this card has a link, put it inside the wrapper component
    if (LinkWrapper) {
        return React.createElement(LinkWrapper, null, cardContent);
    }
    return cardContent;
};
